export default "__VITE_ASSET__2SBk$NGj__"